import { jsx } from "react/jsx-runtime";
import { ContentType } from "../../../enums/contentStack.js";
import { findOneBusinessEntry, DEFAULT_FIELD_EXCEPTIONS, getConfigurationSettingByDeveloperKey } from "../../../services/content/business.lib.js";
import { ModuleSettingsStore } from "../../../utils/contentstack/moduleSettingsStore.js";
import { LANGUAGES_ENTRY_ID_DEV, LANGUAGES_ENTRY_ID_CABC, MODULE_SETTINGS_NAME, WITH_BACKGROUND_CLASS } from "./constants.js";
import { LinkListRow } from "./styles.js";
import { LinkListUI } from "./LinkListUI.js";
async function LinkList({
  containerSx,
  contentType = ContentType.LinkListSimple,
  disablePopover = false,
  enableLivePreview,
  entryId,
  hideTitle = false,
  insideFlyout = false,
  locale = "en-us",
  maxLinksPerColumn,
  sx,
  variant = "SimpleList",
  additionalComponentMap,
  id,
  className,
  dataTestId = "",
  analyticsTitlePrefix
}) {
  var _a;
  let containerAriaLabel, containerDescById;
  const entry = await findOneBusinessEntry(
    contentType,
    entryId,
    locale,
    DEFAULT_FIELD_EXCEPTIONS,
    enableLivePreview
  );
  if (!entry) {
    console.error(
      `LinkList error: could not find entry with id: ${entryId}`
    );
    return null;
  }
  let modifiedEntry = entry;
  if (hideTitle) {
    const { listheader, ...rest } = entry;
    modifiedEntry = rest;
  }
  if (entry.uid === LANGUAGES_ENTRY_ID_DEV || entry.uid === LANGUAGES_ENTRY_ID_CABC) {
    const moduleSettings = await getConfigurationSettingByDeveloperKey(
      ContentType.ModuleSettings,
      MODULE_SETTINGS_NAME,
      locale,
      DEFAULT_FIELD_EXCEPTIONS,
      enableLivePreview
    );
    const store = new ModuleSettingsStore({
      composable_window: [],
      // unused in this moduleSettings
      key_value: moduleSettings.key_value
    });
    containerAriaLabel = store.getKeyValueItem("arialabel");
    containerAriaLabel += ` ${(_a = entry.listheader) == null ? void 0 : _a.title}`;
    containerDescById = store.getKeyValueItem("ariadescribedbyid");
  }
  const {
    background_gradient_style: backgroundGradientStyle = "no-background",
    background_gradient_color: {
      color1: { hex: firstBackgroundColor = "" } = {},
      color2: { hex: secondBackgroundColor = "" } = {}
    } = {},
    background_color: { hex: backgroundColor = "" } = {},
    text_color: { hex: textColor = "" } = {}
  } = modifiedEntry.color_config ?? {};
  const isWithBackground = backgroundGradientStyle !== "no-background";
  if (isWithBackground) {
    variant = "InlineList";
  }
  return /* @__PURE__ */ jsx(
    LinkListRow,
    {
      backgroundColor,
      textColor,
      backgroundGradientStyle,
      firstBackgroundColor,
      secondBackgroundColor,
      className: `${className ? className : ""} ${isWithBackground ? WITH_BACKGROUND_CLASS : ""}`,
      id,
      children: /* @__PURE__ */ jsx(
        LinkListUI,
        {
          additionalComponentMap,
          ariaDescribedBy: containerDescById,
          ariaLabel: containerAriaLabel,
          containerSx,
          dataTestId,
          disablePopover,
          entry: modifiedEntry,
          insideFlyout,
          locale,
          maxLinksPerColumn,
          sx,
          variant,
          analyticsTitlePrefix
        }
      )
    }
  );
}
export {
  LinkList
};
